<template>
<div class="chapter">
<div class="inner_page">
<div id="ack">
<h1>Acknowledgement</h1>
<p style="text-indent:0em;">Helen and Rosie, my sisters, who willingly described their earliest memories.</p><br/>
<p style="text-indent:0em;">Richard, my brother, who prompted me at suitable points along the way.</p><br/>
<p style="text-indent:0em;">Stephen, my brother, who brought the work to fruition.</p><br/>
<p style="text-indent:0em;">Roddy Williams, who clarified areas of fuzziness, gave technical support and offered his own stories.</p><br/>
<p style="text-indent:0em;">Pauline Manfield, my mother’s cousin, a nonagenarian, who offered wartime stories;</p><br/>
<p style="text-indent:0em;">Alison Hutchison and Bob Hutchison, who carefully read the text;</p><br/>
<p style="text-indent:0em;">Brenda Barker, who carefully read the text and helped with graphics.</p><br/>
<p style="text-indent:0em;">And finally, Lyndsay Robinson, who contributed to the cover author photograph, and Sue Jenkins, who gave us permission to use the rear cover painting.</p>
<p style="text-indent:0em;"><br/>
</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?3e0e7629